import http from "../plugins/axios";

const loadUsers = async (params = {}) => {
    const response = await http.get('/api/company/v3/user', {params});
    return response.data;
};

const loadObjects = async (params = {}) => {
    const response = await http.get('/api/company/v3/room', {params});
    return response.data;
};

const loadUser = async (id) => {
    const response = await http.get('/api/company/v3/user/' + id);
    return response.data;
};

const syncUser = async (id) => {
    const response = await http.get(`/api/company/v3/user/${id}/sync`);
    return response.data;
};

const saveUserData = async (id, data) => {
    const response = await http.post('/api/company/v3/user/' + id, data);
    return response.data;
};

const createUser = async (data) => {
    const response = await http.post('/api/company/v3/user', data);
    return response.data;
}

const deleteUser = async (data) => {
    const response = await http.delete('/api/company/v3/user/' + data.id);
    return response.data;
}

const restoreUser = async (data) => {
    const response = await http.get(`/api/company/v3/user/${data.id}/restore`);
    return response.data;
}

const documentsUser = async (id, page) => {
    const response = await http.get(`/api/company/v3/user/${id}/docs`, {params: {page: page}});
    return response.data;
}

const deleteDocUser = async (data) => {
    const response = await http.delete(`/api/company/v3/user/${data.id}/docs/${data.document}`);
    return response.data;
}

const roomsUser = async (id, page) => {
    const response = await http.get(`/api/company/v3/user/${id}/rooms`, {params: {page: page}});
    return response.data;
}

const deleteRoomUser = async (data) => {
    const response = await http.delete(`/api/company/v3/user/${data.id}/rooms/${data.room}`);
    return response.data;
}


const sendReport = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/report',
        params,
        {
            signal: abortController?.signal,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    return data
}


export {
    loadUsers,
    loadUser,
    saveUserData,
    createUser,
    deleteUser,
    restoreUser,
    documentsUser,
    roomsUser,
    deleteDocUser,
    deleteRoomUser,
    syncUser,
    loadObjects,
    sendReport,
};
